module.exports = __webpack_public_path__ + "media/font/iconfont-2c6ef557.ttf";